export default function () {
  return {
    authenticated: false,
    profile: null,
    is_focused_power_dialer: false,
    loading: false,
    // user_settings names with local changes not saved yet; their broadcasts are ignored meanwhile
    pendingUserSettings: []
  }
}
